var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('CChartBar',{attrs:{"datasets":_vm.defaultDatasets,"labels":['Presensi Masuk', 'Presensi Keluar', 'Terlambat', 'Cuti', 'Tanpa Keterangan']}})}
var staticRenderFns = []

export { render, staticRenderFns }